import { http } from '../../../plugins/axios'

const actions = {
  get ({commit}, payload) {
    let url = 'subscription'
    let options = {
      emulateJSON: false
    }
    let params = {
      "perPage": payload.event.perPage,
      "page": payload.event.page,
      "sortKey": payload.event.sortKey,
      "ord": payload.event.ord,
      "find": payload.event.find !== '' ? payload.event.find : undefined
    }
    http.get(url, { params }, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getPlans ({commit}, payload) {
    let url = 'plans'
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetPlans', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getById ({commit}, payload) {
    let url = `subscription/${payload.event.item.id}`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetById', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  post ({commit}, payload) {
    let url = 'subscription'
    let params = {
      "company_id": payload.event.item.company_id,
      "expiration_date": payload.event.item.expiration_date,
      "plan_id": payload.event.item.plan_id
    }
    http.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  put ({commit}, payload) {
    let url = `subscription/${payload.event.item.id}`
    let params = {
      "company_id": payload.event.item.company_id,
      "expiration_date": payload.event.item.expiration_date,
      "plan_id": payload.event.item.plan_id
    }
    http.put(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  delete ({commit}, payload) {
    let url = `subscription/${payload.event.item.id}`
    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  }
}

export default actions